import { IOfferSpendCrudModalLang } from '../../../types/lang'

export const offerSpendCrudModalLang: IOfferSpendCrudModalLang = {
	offer_spend_crud_modal: {
		title_create: 'Create offer spend',
		title_edit: 'Edit offer spend',
		title_remove_single: 'Remove <span>offer spend</span>',
		title_notes_view: 'View notes for offer spend',
		title_notes_edit: 'Edit notes for offer spend',
		title_history_view: 'View history in offer spend',
		title_by_account: 'View offer spend detail info by account {{account}} - {{date}}',
		title_by_account_total: 'View TOTAL offer spend detail info - {{date}}',
		title_by_offer: 'View offer spend detail info by offer {{offer}} - {{date}}',
		title_by_offer_total: 'View TOTAL offer spend detail info - {{date}}',
		title_by_offer_scope: 'View offer spend detail info by offer scope {{offerScope}} - {{date}}',
		title_by_offer_scope_total: 'View TOTAL offer spend detail info - {{date}}',
		field_offer_label: 'Offer',
		field_offer_placeholder: 'Offer',
		field_user_label: 'User',
		field_user_placeholder: 'User',
		field_date_label: 'Date',
		field_date_placeholder: 'Date',
		field_amount_label: 'Amount',
		field_amount_placeholder: 'Type number',
		field_notes_label: 'Notes',
		field_notes_placeholder: 'Notes',
		msg_remove_confirm: 'Are you sure?',
		btn_create: 'Create',
		btn_update: 'Save',
		btn_remove: 'Remove',
		btn_close: 'Close'
	}
}